import { Button, Col, FlexContainer, If, Image, InputNumber, Option, Row, Select, Space, Text } from '@app/components'
import { currenciesWithFlags } from '@app/data'
import { BuyAndSellCurrencyInputPropsWithdraw } from '@app/types'
import { min } from 'lodash'
import { useEffect } from 'react'

export const USDCInput: React.FC<BuyAndSellCurrencyInputPropsWithdraw> = ({
  pay,
  receive,
  balance,
  fee,
  selectedPanel,
  wireTransactionType,
}) => {
  // As USDC === USD so currently implementing like this
  function setAmount(value) {
    if (value == 0) {
      pay.setAmount(0)
      receive.setAmount(0)
    } else if (value) {
      value = min([value, balance])

      pay.setAmount(value)
      if (selectedPanel == '1') {
        receive.setAmount(value - (value * 0.0025 + 50))
      } else if (selectedPanel == '3' || selectedPanel == '5' || selectedPanel == '6') {
        receive.setAmount(value - (value * 0.0025 + 5))
      } else if (selectedPanel == '2' || selectedPanel == '4') {
        receive.setAmount(value)
      } else if (selectedPanel == '7') {
        receive.setAmount(value - (value * 0.0025 + 5))
      }
    } else {
      pay.setAmount(0)
      receive.setAmount(0)
    }
  }

  useEffect(() => {
    setAmount(pay.amount)
  }, [selectedPanel, wireTransactionType, fee])

  /** It renders dropdown options for both Pay(Country currencies) and Receive(Crypto Currencies) Input */
  const InputDropdownOptions = ({ currencyOptions, currencyType, state }) => {
    return (
      <Select value={state.type} style={{ width: '130px' }} onSelect={(v) => state.setType(v)}>
        {currencyOptions
          .filter(function (i) {
            return ['USD'].includes(i.code)
          })
          .map((currency) => {
            return (
              <Option key={currency.code} value={currency.code}>
                <FlexContainer gap={'10px'} alignItems="center">
                  {currencyType === 'COUNTRY' ? <Image preview={false} src={currency.flag} /> : currency.flag}
                  <Text>{currency.code}</Text>
                </FlexContainer>
              </Option>
            )
          })}
      </Select>
    )
  }

  /** Get Currency Inputs */
  const getInputDropdowns = (input) => {
    return (
      <Space direction="vertical" width="100%">
        <Text>{input.title}</Text>
        <If condition={pay.amount > balance}>
          <InputNumber
            min={0}
            max={balance}
            width="100%"
            status="error"
            addonAfter={input.options}
            placeholder={'Enter Amount'}
            value={input.state.amount}
            onChange={(v) => setAmount(v as number)}
          />
        </If>
        <If condition={pay.amount <= balance}>
          <InputNumber
            min={0}
            width="100%"
            addonAfter={input.options}
            placeholder={'Enter Amount'}
            value={input.state.amount}
            onChange={(v) => setAmount(v as number)}
          />
        </If>
      </Space>
    )
  }

  const currencyListOptions = [
    {
      title: (
        <>
          Withdraw{' '}
          <Button type="link" size="small" onClick={() => setAmount(balance)}>
            (Max)
          </Button>
        </>
      ),
      options: <InputDropdownOptions currencyType={'COUNTRY'} currencyOptions={currenciesWithFlags} state={pay} />,
      state: pay,
    },
  ]

  return (
    <Row>
      {currencyListOptions.map((input, index) => (
        <Col span={24} key={index}>
          {getInputDropdowns(input)}
        </Col>
      ))}
    </Row>
  )
}
